import React from "react";

import { Sidebar } from "../../layout/Sidebar/Sidebar";
import SettingsComponent from "../../components/Portal/settings_page/settings_component";

const SettingsPage = () => {
  return (
    <>
      <Sidebar childComponent={<SettingsComponent />} activeText="Account" />
    </>
  );
};

export default SettingsPage;
